
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SideNav extends Vue {
    @Prop() private name!: string;
    @Prop() private sub_name!: string;
    @Prop() private menu:any;
    @Prop() private position!: string;
    private newMenu:any;
    private toggleStatus:boolean = false;
    private created(){
        let dummy:any = [];
        this.menu.forEach((v:any) => {
            delete v.title
            for(let i in v.items){
                dummy.push(v.items[i]);
            }
        });
        this.newMenu = dummy;
    }
    private computed(){


    };
    private goToHome() {
        if (this.$route.path !== '/') {
            this.$router.push('/');
        }
    }
    private toggleMenu() {
        this.checkLockWindow(this.toggleStatus);
        this.toggleStatus ? this.toggleStatus = false : this.toggleStatus = true;
    }
    private closeOverlay(){
        this.toggleStatus = false;
        this.cancelDisMouseWheel();
    }
    private checkLockWindow(status:boolean) {
        if (!status) {
            this.disabledMouseWheel();
        }else{
            this.cancelDisMouseWheel();
        }
    }
    //阻止浏览器事件
    private disabledMouseWheel() {  
        $("body").css("overflow","hidden");
    }
    //取消阻止浏览器事件
    private cancelDisMouseWheel(){
        $("body").css("overflow","auto");
    }  

    private clearCache() {
        (window as any).clearPwaCache();
    };


}
